var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF3D62"
    },
    cx: 256,
    cy: 255.996,
    r: 255.996
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2001B"
    },
    d: "M511.484,272.108l-82.486-82.486L256.003,68.126L83.009,189.622v220.001l87.859,87.859  C197.505,506.874,226.154,512,256.004,512C391.976,512,503.169,405.986,511.484,272.108z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC000"
    },
    points: "256.003,68.126 83.009,189.622 83.009,409.623 428.998,409.623 428.998,189.622 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9A600"
    },
    points: "428.998,189.622 256.003,68.126 256,68.128 256,409.623 428.998,409.623 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.627,
    y: 110.465,
    style: {
      fill: "#FFFFFF"
    },
    width: 296.747,
    height: 282.463
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 110.465,
    style: {
      fill: "#E1E1E3"
    },
    width: 148.373,
    height: 282.463
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 162.149,
    y: 203.042,
    style: {
      fill: "#EBB300"
    },
    width: 187.703,
    height: 17.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.149,
    y: 248.964,
    style: {
      fill: "#EBB300"
    },
    width: 187.703,
    height: 17.24
  })), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 248.964,
    style: {
      fill: "#D9A600"
    },
    width: 93.851,
    height: 17.238
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDF47"
    },
    points: "256.003,294.099 83.009,189.622 83.009,409.623 256.003,409.623 428.998,409.623   428.998,189.622 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD400"
    },
    points: "256.003,294.099 256,294.097 256,409.623 256.003,409.623 428.998,409.623 428.998,189.622   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFEC97"
    },
    points: "83.009,409.623 256.003,294.099 428.998,409.623 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.149,
    y: 157.13,
    style: {
      fill: "#EBB300"
    },
    width: 187.703,
    height: 17.238
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 157.13,
    style: {
      fill: "#D9A600"
    },
    width: 93.851,
    height: 17.24
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 203.042,
    style: {
      fill: "#D9A600"
    },
    width: 93.851,
    height: 17.24
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDF47"
    },
    points: "428.998,409.623 256.003,294.099 256,294.101 256,409.623 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.af1768268bdeac1599a7ec617c4f722d.svg";
export { ForwardRef as ReactComponent };